import React, { useEffect, useState, Fragment } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import CarouselVacantes from "../../components/Slick/CarouselVacantes";
import CardCentros from "../../components/Aplicant/CardCentros";
import useMediaQuery from "../../Hooks/useMediaQuery";

import LinkButton from "../../utils/LinkButton";

import "../../static/css/custom.css";

import CardCursos from "../../components/Aplicant/CardCursos";
import ComunidadKrezco from "../../components/Aplicant/ComunidadKrezco";
import CarouselEmpresa from "../../components/Slick/CarouselEmpresa";
import user from "../../static/images/user_default.png";
import useToggle from "../../Hooks/useToggle";
import FabHome from "../../components/Slide/FaqHome";
import Fabcerrar from "../../components/Slide/Fabcerrar";
import CardGroups from "../../components/Aplicant/CardGroups";

function Home() {
  const [applicantData, setapplicantData] = useState("");

  //const [cursos, setcursos] = useState([]);

  //const [vacantstep, setvacantstep] = useState(0);
  const [lastVacantApplied, setlastVacantApplied] = useState([]);
  const [comunidadKrezcoList, setcomunidadKrezcoList] = useState([]);
  const isMobile = useMediaQuery("(max-width: 927px)");
  const matchedMobile = useMediaQuery("(max-width: 927px)");
  const [isPanelOpen, togglePanel] = useToggle(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    //Validamos que el perfil este completado, de lo contrario lo redireccionamos a la pagina perfil
    const getApplicant = async () => {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("tok");

      let userId = localStorage.getItem("userId");
      axios.get("access/applicant/" + userId).then((result) => {
        if (result.status === 200) {
          /*if (!result.data.applicantProfile.hasOwnProperty("userId")) {
              history.push("/user/Perfil");
            }*/
          setapplicantData(result.data.applicantProfile);
          getlastVacantApplied(result.data.applicantProfile);
          localStorage.setItem(
            "applicantId",
            result.data.applicantProfile.applicantProfileId
          );
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };

    function getlastVacantApplied(data) {
      let config = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };

      axios
        .get(
          "company-vacant/list-applicant-vacants/" + data.applicantProfileId,
          config
        )
        .then((resultLst) => {
          if (resultLst.data?.length > 0)
            setlastVacantApplied(resultLst.data[0]);
        });
    }

    const getComunidadKrezco = async () => {
      await axios.get("/access/list-random-applicants").then((result) => {
        if (result.status === 200) {
          setcomunidadKrezcoList(result.data);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };

    getApplicant();
    getComunidadKrezco();
  }, []);

  return (
    <Fragment>
      {matchedMobile && (
        <FabHome fabAction={togglePanel} isOpen={isPanelOpen} />
      )}

      <div className="content">
        <div className="content-body row">
          <div id="left-panel" className={isPanelOpen ? "open" : ""}>
            <div className="card-container text-center">
              <div className="current-user border-purple">
                <img
                  id="headerProfilePic"
                  src={applicantData.image != null ? applicantData.image : user}
                  style={{
                    width: "75px",
                    height: "75px",
                    borderRadius: "6px",
                    // backgroundImage: `url(${user})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  alt="Profile Icon"
                ></img>
              </div>
              <p
                style={{
                  textAlign: "center",
                  color: "#696969",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                }}
              >
                {applicantData.names} {applicantData.lastnames}
              </p>
              <p
                style={{
                  textAlign: "center",
                  color: "#696969",
                  fontWeight: "600",
                  fontSize: "0.75rem",
                  marginBottom: "10px",
                }}
              >
                {applicantData.profession}
              </p>
              <div className="d-grid gap-3">
                <LinkButton className="btn-deg p-2" to="/user/Perfil">
                  Ver Perfil
                </LinkButton>
                {matchedMobile && (
                  <Fabcerrar fabAction={togglePanel} isOpen={isPanelOpen} />
                )}
                <LinkButton className="btn-deg p-2" to="/user/Guardados">
                  Empleos Guardados
                </LinkButton>
                <LinkButton className="btn-deg p-2" to="/user/Aplicados">
                  Empleos Guardados
                </LinkButton>
              </div>
            </div>
            <div className="card-container" id="container-krezco">
              <p className="title big" style={{ textAlign: "center" }}>
                Conoce a la Comunidad KREZCO
              </p>
              <hr></hr>
              <ComunidadKrezco data={comunidadKrezcoList}></ComunidadKrezco>
              <hr></hr>
              <div className="text-center">
                <a
                  className="sub-title fw-semi-bold link-purple"
                  href="/user/Conecta"
                  type="button"
                >
                  Ver más
                </a>
              </div>
            </div>
            {/* <div className="card-container">
              <p className="title big">Tu Calendario</p>
              <hr></hr>
              <div id="my-calendar"></div>
            </div> */}
          </div>

          <div id="center-panel">
            <div className="card-container">
              <p
                className="pad-carousel-title2"
                style={{ textAlign: "center", textOverflow: "ellipsis" }}
              >
                Vacantes que podrían interesarte
              </p>
              <CarouselVacantes
                id="Vacantes"
                isMobile={isMobile}
              ></CarouselVacantes>
            </div>

            <div className="card-container">
              <p
                className="title big pad-carousel-title"
                style={{ textAlign: "center", width: "100%" }}
              >
                <strong>Conoce nuestros Aliados</strong>
              </p>
              <p
                className="fw-semi-bold sub-title big pad-carousel-title col-sm-2"
                style={{ textAlign: "center" }}
              >
                Empresas:
              </p>
              <CarouselEmpresa
                id="Empresas"
                isMobile={isMobile}
              ></CarouselEmpresa>

              <p
                className="fw-semi-bold sub-title big pad-carousel-title col-sm-3"
                style={{ textAlign: "center" }}
              >
                Centros de Formación:
              </p>

              <CardCentros
                id="CentrosFormacion"
                qty={isMobile ? 1 : 3}
              ></CardCentros>
            </div>

            <div className="card-container">
              <p
                className="title big pad-carousel-title"
                style={{ textAlign: "center" }}
              >
                Adquiere nuevas habilidades e impulsa tu conocimiento
              </p>

              <CardCursos id="Videos" qty={isMobile ? 1 : 3}></CardCursos>
            </div>

            <div className="card-container">
              <p
                className="title big pad-carousel-title"
                style={{ textAlign: "center" }}
              >
                Forma parte de Grupos de intereses en común
              </p>

              <CardGroups id="groups" qty={isMobile ? 1 : 3} />
            </div>
          </div>
          <div id="right-panel">
            <div className="card-container">
              <p className="title big" style={{ textAlign: "center" }}>
                Estado de Aplicaciones
              </p>

              {lastVacantApplied?.length === 0 ? (
                <div>
                  <p className="title" style={{ textAlign: "center" }}>
                    Todavía no has aplicado a ninguna vacante
                  </p>
                </div>
              ) : (
                <div>
                  <div className="img-community border-gray">
                    <img
                      src={
                        lastVacantApplied.companyDTOResponse.fotoPerfilEmpresa
                          ? lastVacantApplied.companyDTOResponse
                              .fotoPerfilEmpresa
                          : user
                      }
                      alt="applicacion"
                      style={{
                        width: "62px",
                        height: "62px",
                        borderRadius: "9px",
                      }}
                    ></img>
                  </div>
                  <div className="content-info-card">
                    <span className="title">
                      {lastVacantApplied.companyDTOResponse.cargo}
                    </span>
                    <br></br>
                    <span className="sub-title">
                      {lastVacantApplied.companyDTOResponse.name}
                    </span>
                    <br></br>
                  </div>
                </div>
              )}
              <hr></hr>
              <div className="text-center">
                <a
                  className="sub-title fw-semi-bold link-purple"
                  href="/user/Aplicados"
                >
                  Ver tus aplicaciones
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Home;
